import { IMAGE_BASE_URL } from 'constants/api.constants';

export const getImageUrl = (imagePath, fallback = null) => {
  if (!imagePath) {
    return fallback;
  }

  // Already a complete URL
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }

  // Remove leading slash to avoid //
  return `${IMAGE_BASE_URL}/${imagePath.replace(/^\/+/, '')}`;
};